import { Navbar, Footer } from "@/components/Layout";
import { TreePine, Target, Users, Shield } from "lucide-react";
import { useSeo } from "@/hooks/useSeo";

export default function About() {
  useSeo({
    title: "Om TimberNet — Sveriges marknadsplats för skog",
    description: "Lär känna TimberNet — vår mission att digitalisera och förenkla den svenska skogsmarknaden för skogsägare, leverantörer och köpare.",
    path: "/om-oss",
  });
  return (
    <div className="flex min-h-screen flex-col">
      <Navbar />
      <div className="container max-w-3xl flex-1 py-8">
        <h1 className="mb-6 font-display text-2xl font-bold md:text-3xl">Om TimberNet</h1>
        <p className="mb-8 text-muted-foreground leading-relaxed">
          TimberNet är Sveriges digitala marknadsplats för skogstjänster och virke. Vi gör det enkelt att boka professionella skogstjänster, köpa ved och virke, eller sälja från din egen skog — allt på ett tryggt och transparent sätt.
        </p>

        <div className="grid gap-6 sm:grid-cols-2">
          {[
            { icon: Target, title: "Vår mission", desc: "Att förenkla och digitalisera den svenska skogsmarknaden för alla — från skogsägare till privatpersoner." },
            { icon: Users, title: "För alla", desc: "Oavsett om du äger skog, behöver en arborist eller vill köpa ved till kaminen — TimberNet är till för dig." },
            { icon: Shield, title: "Trygghet först", desc: "Med verifierade leverantörer, omdömen och säker betalning kan du alltid känna dig trygg." },
            { icon: TreePine, title: "Hållbar skog", desc: "Vi främjar hållbart skogsbruk genom att koppla samman rätt aktörer och sprida kunskap." },
          ].map((item) => (
            <div key={item.title} className="rounded-lg border border-border bg-card p-5">
              <div className="mb-3 flex h-10 w-10 items-center justify-center rounded-lg bg-primary/10">
                <item.icon className="h-5 w-5 text-primary" />
              </div>
              <h3 className="mb-1 font-sans text-base font-semibold">{item.title}</h3>
              <p className="text-sm text-muted-foreground">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
}
